import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MessageContainer extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }
   
    render() {
        let isValid = this.props.isValidNumber ? 'valid' : 'invalid';
        let isShow = this.props.showMessage ? 'show' : 'none';
        return(
            <div className={`message ${isShow} ${isValid}`}>
                {this.props.message}
            </div>
        )
    }  
}

export default MessageContainer;

MessageContainer.propTypes = {
    isValidNumber: PropTypes.bool.isRequired,
    showMessage: PropTypes.bool.isRequired,
    message:  PropTypes.string
}